import { JsonDecoder } from 'ts.data.json';
import { eSignDecoder } from '../order/decoder';
import { OrderResendResponse } from './model';

export const orderResendResponseDecoder = JsonDecoder.object<OrderResendResponse>(
    {
        id: JsonDecoder.string,
        eSign: eSignDecoder
    },
    'OrderResendResponse'
);
